module.exports = __webpack_public_path__ + "img/dd@2x.6d991707.png";